/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import SeQuenXLogo from "../assets/svg/SeQuenXLogo.svg";
import UKLogo from "../assets/svg/united-kingdom.svg";
import NLLogo from "../assets/svg/netherlands.svg";
import "./Navbar.css";
import i18n from "./../utils/i18n";
import { useTranslation } from "react-i18next";

const supportedLanguages = ["en", "nl"];

const Navbar = () => {
  const [click, setClick] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const [langStatus, setLangStatus] = useState("en");
  const { t } = useTranslation();

  useEffect(() => {
    const temp = sessionStorage.getItem("language");
    if (temp === null || temp === undefined) {
      sessionStorage.setItem("language", "en");
    }
    setLangStatus(temp);

    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  useEffect(() => {
    // Close sidebar and dropdown when location changes
    setClick(false);
    setDropdown(false);
  }, [location]);

  const handleClick = () => {
    setClick(!click);
    if (click) {
      setDropdown(false);
    }
  };

  const handleDropdown = () => {
    setDropdown(!dropdown);
  };

  const setLanguageInCookie = (language) => {
    if (
      supportedLanguages.includes(language) &&
      sessionStorage.getItem("language") !== language
    ) {
      sessionStorage.setItem("language", language);
      i18n.changeLanguage(language);
      setLangStatus(language);
    }
  };

  return (
    <nav className={`navbar-container ${scrolled ? "scrolled" : ""}`}>
      <div className="container mx-auto py-4 navbar">
        <div className="logo">
          <NavLink to="/" exact>
            <img src={SeQuenXLogo} alt="SeQuenX Logo" className="logo-img" />
          </NavLink>
        </div>

        <div className={`nav-menu ${click ? "active" : ""}`}>
          <div className="nav-items">
            {click && (
              <div className="close-button" onClick={handleClick}>
                <FaTimes className="icon" />
              </div>
            )}
            <NavLink
              to="/about-us"
              className="nav-item"
              activeClassName="active"
            >
              {t("header.aboutus")}
            </NavLink>

            <div
              className={`nav-item dropdown-container ${
                dropdown ? "active" : ""
              }`}
            >
              <span className="dropdown-toggle" onClick={handleDropdown}>
                {t("header.services")}
              </span>
              <div className="dropdown-menu">
                <NavLink
                  to="/service/software-dev"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={() => setDropdown(false)}
                >
                  {t("header.service1")}
                </NavLink>
                <NavLink
                  to="/service/software-quality-assurance"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={() => setDropdown(false)}
                >
                  {t("header.service2")}
                </NavLink>
                <NavLink
                  to="/service/oss-compliance-and-security"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={() => setDropdown(false)}
                >
                  {t("header.service3")}
                </NavLink>
                <NavLink
                  to="/service/software-consultacy-and-training"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={() => setDropdown(false)}
                >
                  {t("header.service4")}
                </NavLink>
                <NavLink
                  to="/service/ecommerce"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={() => setDropdown(false)}
                >
                  {t("header.ecommerce")}
                </NavLink>
                <NavLink
                  to="/service/digital-marketing"
                  className="dropdown-item"
                  activeClassName="active"
                  onClick={() => setDropdown(false)}
                >
                  {t("header.digitalMarketing")}
                </NavLink>
              </div>
            </div>

            <NavLink
              to="/service/remote-teams"
              className="nav-item"
              activeClassName="active"
            >
              {t("header.remoteTeams")}
            </NavLink>

            <NavLink
              to="/service/recruitment"
              className="nav-item"
              activeClassName="active"
            >
              {t("header.recruitment")}
            </NavLink>

            <NavLink to="/team" className="nav-item" activeClassName="active">
              {t("header.team")}
            </NavLink>
            <NavLink
              to="/careers"
              className="nav-item"
              activeClassName="active"
            >
              {t("header.careers")}
            </NavLink>
            <NavLink
              to="/contact-us"
              className="nav-item"
              activeClassName="active"
            >
              {t("header.contact")}
            </NavLink>
          </div>

          <div className="language-switcher">
            <button
              className={`lang-btn ${langStatus === "nl" ? "active" : ""}`}
              onClick={() => setLanguageInCookie("nl")}
            >
              <img src={NLLogo} alt="Dutch" />
              <span>NL</span>
            </button>
            <button
              className={`lang-btn ${langStatus === "en" ? "active" : ""}`}
              onClick={() => setLanguageInCookie("en")}
            >
              <img src={UKLogo} alt="English" />
              <span>EN</span>
            </button>
          </div>
        </div>

        <div className="hamburger" onClick={handleClick}>
          {!click && <FaBars className="icon" />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
